<template>
  <div class="wrapper">
    <img class="img" :src="img" alt="">
  </div>
</template>
<script>
import weChatShareApi from "../../assets/js/weChatShare";
export default {
  components: {},
  props: {},
  mixins: [weChatShareApi],
  data() {
    return {
      img:'',
    };
  },
  watch: {},
  methods: {
    initPage(){
      let option = {
          title: '有米@'+this.userInfo.name + "的店铺",
          desc: "欢迎光临我的店铺",
          link: location.origin + "/?supNbr=" + this.userInfo.nbr,
          images: this.userInfo.imgUrl
      };
      this.weChatShare(option);
    }
  },
  created() {
    document.title = "新手指南";
    let type = this.$route.query.type || "";
    let num = this.$route.query.num || "";
    this.img= require(`../../assets/images/fingerpost/fingerpost_${type}_${num}.jpg`)
    this.initPage()
  },
  mounted() {
  }
};
</script>
<style scoped lang='less'>
.wrapper{
  min-height: 100vh;
  background: #2B7EE8;
}
.img{
  width: 100vw;
}
</style>



// WEBPACK FOOTER //
// src/components/information/fingerpostDetail.vue